import * as React from "react"
import { Paper, DownloadItem, Seo } from "components"
import { AfterPage } from "types/afterjs"
import { DownloadList } from "types/download-center"
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table"

import fetchDownload from "./actions"
import "./downloadCenterPage.scss"

const DownloadCenterPage: AfterPage<{ data: DownloadList }> = ({ data }) => {
	return (
		<>
			<Seo
				title="مرکز دانلود"
				description="دانلود رایگان آنتی ویروس اورجینال از سرور مرجع آنتی ویروس ایران و سرور اصلی سازنده آنتی ویروس"
				path="/download-center"
			/>
			<Paper className="text-center">
				<Table className="table table-hover">
					<Thead>
						<Tr>
							<Th>نما</Th>
							<Th>نام محصول</Th>
							<Th>نگارش</Th>
							<Th>سیستم عامل</Th>
							<Th>
								حجم فایل{" "}
								<span className="d-none d-sm-block">
									(مگابایت)
								</span>
							</Th>
							<Th>
								دانلود از سرور
								<br /> مرجع آنتی ویروس
							</Th>
							<Th>
								دانلود از سرور
								<br /> شرکت تولید کننده
							</Th>
						</Tr>
					</Thead>
					<Tbody>
						{data.files.map((file) => (
							<DownloadItem key={file.id} {...file} />
						))}
					</Tbody>
				</Table>
			</Paper>
		</>
	)
}

DownloadCenterPage.getInitialProps = async () => {
	try {
		const { data } = await fetchDownload()
		return { data }
	} catch (error) {
		return { error }
	}
}

export default DownloadCenterPage
